(function () {
  "use strict";
  var sc = document.getElementById("bsl-scroll"),
    bl = document.getElementById("bsl-left"),
    br = document.getElementById("bsl-right"),
    blm = document.getElementById("bsl-left-m"),
    brm = document.getElementById("bsl-right-m");

  /* R14: Cache rect + scrollWidth/clientWidth → keine forced reflows im scroll-Handler */
  var _bslStepCache = null,
    _bslWidthCache = null;
  function invalidateBslCache() {
    _bslStepCache = null;
    _bslWidthCache = null;
  }
  window.addEventListener("resize", invalidateBslCache, { passive: true });
  function getScrollStep() {
    if (_bslStepCache != null) return _bslStepCache;
    if (!sc) {
      _bslStepCache = 300;
      return 300;
    }
    var firstCard = sc.querySelector(".bsl__card");
    if (firstCard) {
      var rect = firstCard.getBoundingClientRect();
      _bslStepCache = rect.width + 16;
      return _bslStepCache;
    }
    _bslStepCache = sc.clientWidth * 0.85;
    return _bslStepCache;
  }
  function getMaxScroll() {
    if (_bslWidthCache != null) return _bslWidthCache;
    if (!sc) {
      _bslWidthCache = 0;
      return 0;
    }
    _bslWidthCache = sc.scrollWidth - sc.clientWidth;
    return _bslWidthCache;
  }
  var _bslScrollRAF = null;
  function checkScroll() {
    if (!sc || _bslScrollRAF) return;
    _bslScrollRAF = requestAnimationFrame(function () {
      _bslScrollRAF = null;
      var sl = sc.scrollLeft,
        max = getMaxScroll();
      var atStart = sl < 10,
        atEnd = sl >= max - 10;
      if (bl) bl.disabled = atStart;
      if (br) br.disabled = atEnd;
      if (blm) blm.disabled = atStart;
      if (brm) brm.disabled = atEnd;
    });
  }
  function scrollLeftFn() {
    if (!sc) return;
    sc.scrollBy({ left: -getScrollStep(), behavior: "smooth" });
    setTimeout(checkScroll, 400);
  }
  function scrollRightFn() {
    if (!sc) return;
    sc.scrollBy({ left: getScrollStep(), behavior: "smooth" });
    setTimeout(checkScroll, 400);
  }
  if (sc) {
    sc.addEventListener("scroll", checkScroll, { passive: true });
    /* Initial state: defer to idle time to avoid forced reflow on critical path */
    if ("requestIdleCallback" in window) {
      requestIdleCallback(checkScroll, { timeout: 1500 });
    } else {
      setTimeout(checkScroll, 300);
    }
  }
  if (bl) bl.addEventListener("click", scrollLeftFn);
  if (br) br.addEventListener("click", scrollRightFn);
  if (blm) blm.addEventListener("click", scrollLeftFn);
  if (brm) brm.addEventListener("click", scrollRightFn);

  var cards = document.querySelectorAll(".bsl__card[data-hue]");
  var _bslCardId = 0;
  /* Assign unique per-card ID for shader key isolation */
  cards.forEach(function (c) { c.dataset.bslId = _bslCardId++; });

  /* Reduced motion check (ui-ux-pro-max) */
  var prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (prefersReduced) {
    cards.forEach(function (c) {
      c.classList.add("is-visible");
    });
  }

  /* IntersectionObserver stagger reveal (vercel-react: single observer) */
  if (!prefersReduced && "IntersectionObserver" in window) {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            setTimeout(
              function () {
                e.target.classList.add("is-visible");
              },
              Array.prototype.indexOf.call(cards, e.target) * 60,
            );
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -30px 0px" },
    );
    cards.forEach(function (c) {
      obs.observe(c);
    });
  } else if (!prefersReduced) {
    cards.forEach(function (c) {
      c.classList.add("is-visible");
    });
  }

  /* Three.js shader — skip on touch/slow/low-end (shader is hover-only, mobile has no hover) */
  var _bsCon =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    {};
  var _bsSaveData = !!(
    _bsCon.saveData || /^(2g|slow-2g)$/.test(_bsCon.effectiveType || "")
  );
  var _bsTouchOnly = window.matchMedia && matchMedia("(hover: none)").matches;
  var _bsLowEnd =
    (navigator.deviceMemory && navigator.deviceMemory < 4) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4);
  /* Shader safety helpers */
  function hasWebGLSupport() {
    try {
      var c = document.createElement("canvas");
      return !!(
        window.WebGLRenderingContext &&
        (c.getContext("webgl") || c.getContext("experimental-webgl"))
      );
    } catch (e) {
      return false;
    }
  }
  function validShaderSource(src) {
    return typeof src === "string" && src.trim().length > 0;
  }
  function cleanupShader(inst) {
    if (!inst) return;
    try {
      cancelAnimationFrame(inst.frameId);
    } catch (e) {}
    try {
      if (inst.geometry) inst.geometry.dispose();
    } catch (e) {}
    try {
      if (inst.material) inst.material.dispose();
    } catch (e) {}
    try {
      if (inst.renderer) inst.renderer.dispose();
    } catch (e) {}
    try {
      if (
        inst.mount &&
        inst.renderer &&
        inst.renderer.domElement &&
        inst.mount.contains(inst.renderer.domElement)
      )
        inst.mount.removeChild(inst.renderer.domElement);
    } catch (e) {}
  }
  function enableShaderFallback(card, mount) {
    if (card) card.classList.add("bsl--shader-fallback");
    if (mount) mount.classList.add("is-fallback");
  }

  var FS = [
    "precision mediump float;",
    "uniform vec2 u_resolution;uniform float u_time;uniform float u_hue;",
    "vec3 hsv2rgb(vec3 c){vec4 K=vec4(1.0,2.0/3.0,1.0/3.0,3.0);vec3 p=abs(fract(c.xxx+K.xyz)*6.0-K.www);return c.z*mix(K.xxx,clamp(p-K.xxx,0.0,1.0),c.y);}",
    "float rnd(vec2 st){return fract(sin(dot(st,vec2(12.9898,78.233)))*43758.5453);}",
    "float ns(vec2 st){vec2 i=floor(st);vec2 f=fract(st);vec2 u=f*f*(3.0-2.0*f);return mix(mix(rnd(i),rnd(i+vec2(1,0)),u.x),mix(rnd(i+vec2(0,1)),rnd(i+vec2(1,1)),u.x),u.y);}",
    "float fbm(vec2 st){float v=0.0;float a=0.5;for(int i=0;i<6;i++){v+=a*ns(st);st*=2.0;a*=0.5;}return v;}",
    "mat2 rot(float a){return mat2(cos(a),-sin(a),sin(a),cos(a));}",
    "void main(){",
    "vec2 uv=(gl_FragCoord.xy*2.0-u_resolution.xy)/min(u_resolution.x,u_resolution.y);",
    "float t=u_time;vec2 p=uv*rot(t*0.15);",
    "float n1=fbm(p*1.2+vec2(t*0.12,t*0.22));",
    "float n2=fbm(p*2.0+n1+vec2(-t*0.28,t*0.18));",
    "float n3=fbm(p*3.2+n2+vec2(t*0.12,-t*0.22));",
    "float fn=n1*0.6+n2*0.25+n3*0.15;",
    "float s=0.65+fn*0.35;float v=0.12+pow(fn,2.2)*1.8;v+=pow(smoothstep(0.65,1.0,fn),2.5)*1.2;",
    "vec3 col=hsv2rgb(vec3(u_hue/360.0+fn*0.12,s,v));",
    "col*=1.0-smoothstep(0.5,1.4,length(uv));",
    "float alpha=smoothstep(0.02,0.15,length(col))*0.85;",
    "gl_FragColor=vec4(col,alpha);}",
  ].join("\n");
  var VS = "void main(){gl_Position=vec4(position,1.0);}";
  var active = {},
    leaveTimers = {},
    _bslFailed = {};

  function createShader(card) {
    var key = "bsl-c" + (card.dataset.bslId || card.getAttribute("data-hue") || "0");
    if (_bslFailed[key]) return null;
    var mount = card.querySelector(".bsl__shader");
    if (!mount || typeof THREE === "undefined") {
      _bslFailed[key] = true;
      return null;
    }
    if (!hasWebGLSupport()) {
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    if (!validShaderSource(VS) || !validShaderSource(FS)) {
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var w = mount.clientWidth || 200,
      h = mount.clientHeight || 260;
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true });
    } catch (e) {
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    if (!renderer) {
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    try {
      renderer.setPixelRatio(1);
      renderer.setSize(Math.round(w * 0.5), Math.round(h * 0.5), false);
      renderer.domElement.style.width = "100%";
      renderer.domElement.style.height = "100%";
      mount.appendChild(renderer.domElement);
    } catch (e) {
      try {
        renderer.dispose();
      } catch (ex) {}
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var scene, cam, uni, geo, mat, mesh;
    try {
      scene = new THREE.Scene();
      cam = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
      var hue = parseFloat(card.getAttribute("data-hue")) || 263;
      uni = {
        u_time: { value: 0 },
        u_resolution: { value: new THREE.Vector2(w * 0.5, h * 0.5) },
        u_hue: { value: hue },
      };
      geo = new THREE.PlaneGeometry(2, 2);
      mat = new THREE.ShaderMaterial({
        uniforms: uni,
        vertexShader: VS,
        fragmentShader: FS,
        transparent: true,
      });
      mesh = new THREE.Mesh(geo, mat);
      scene.add(mesh);
    } catch (e) {
      try {
        if (geo) geo.dispose();
      } catch (ex) {}
      try {
        if (mat) mat.dispose();
      } catch (ex) {}
      try {
        if (renderer) renderer.dispose();
      } catch (ex) {}
      try {
        if (
          mount &&
          renderer &&
          renderer.domElement &&
          mount.contains(renderer.domElement)
        )
          mount.removeChild(renderer.domElement);
      } catch (ex) {}
      _bslFailed[key] = true;
      enableShaderFallback(card, mount);
      return null;
    }
    var start = performance.now(),
      fid = 0;
    function animate() {
      fid = requestAnimationFrame(animate);
      uni.u_time.value = (performance.now() - start) / 1000;
      try {
        renderer.render(scene, cam);
      } catch (e) {
        cancelAnimationFrame(fid);
        cleanupShader({
          frameId: fid,
          geometry: geo,
          material: mat,
          renderer: renderer,
          mount: mount,
        });
        _bslFailed[key] = true;
        enableShaderFallback(card, mount);
        fid = 0;
      }
    }
    animate();
    return {
      renderer: renderer,
      material: mat,
      geometry: geo,
      frameId: fid,
      mount: mount,
    };
  }

  /* Cleanup: stop RAF loop, remove canvas, dispose GPU resources */
  function destroyShader(d) {
    if (!d) return;
    cancelAnimationFrame(d.frameId);
    if (d.mount && d.renderer && d.mount.contains(d.renderer.domElement))
      d.mount.removeChild(d.renderer.domElement);
    if (d.geometry) d.geometry.dispose();
    if (d.material) d.material.dispose();
    if (d.renderer) {
      d.renderer.dispose();
    }
  }

  /* Skip shader setup if reduced motion */
  if (prefersReduced) return;

  /* vercel-react: RAF-throttled mousemove for 3D tilt */
  var ticking = {};

  /* R18: Invalidate cached rects on scroll/resize to avoid forced reflow every frame */
  var _rectCache = {};
  var _invalidate = function () {
    _rectCache = {};
  };
  window.addEventListener("scroll", _invalidate, { passive: true });
  window.addEventListener("resize", _invalidate, { passive: true });

  cards.forEach(function (card) {
    var inner = card.querySelector(".bsl__card-inner");
    var glass = card.querySelector(".bsl__glass");
    var img = card.querySelector(".bsl__img");
    var shaderEl = card.querySelector(".bsl__shader");
    var color = card.getAttribute("data-color") || "#8B5CF6";
    var key = "bsl-c" + (card.dataset.bslId || "0");

    card.addEventListener("mouseenter", function () {
      /* Cancel pending destroy so shader isn't killed mid-animation */
      if (leaveTimers[key]) {
        clearTimeout(leaveTimers[key]);
        leaveTimers[key] = null;
      }
      /* Destroy previous shader for this card (if still alive) so animation restarts fresh */
      if (active[key]) {
        destroyShader(active[key]);
        delete active[key];
      }
      active[key] = createShader(card);
      if (shaderEl) {
        shaderEl.classList.remove("is-leaving", "is-active", "is-settle");
        shaderEl.style.transform = "scale(0)";
        shaderEl.style.opacity = "0";
      }
      /* R18: Cache rect on enter — no forced reflow in mousemove */
      if (inner) _rectCache[key] = inner.getBoundingClientRect();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (shaderEl) {
            shaderEl.style.transform = "";
            shaderEl.style.opacity = "";
            shaderEl.classList.add("is-active");
          }
          setTimeout(function () {
            if (shaderEl) shaderEl.classList.add("is-settle");
          }, 800);
        });
      });
      if (img)
        img.style.filter =
          "drop-shadow(0 0 24px " +
          color +
          "99) drop-shadow(0 0 50px " +
          color +
          "4d)";
    });

    /* R18: RAF throttle + cached rect — zero forced reflows */
    card.addEventListener("mousemove", function (e) {
      if (ticking[key]) return;
      ticking[key] = true;
      requestAnimationFrame(function () {
        if (!inner) {
          ticking[key] = false;
          return;
        }
        var r = _rectCache[key];
        if (!r) {
          r = _rectCache[key] = inner.getBoundingClientRect();
        }
        inner.style.transform =
          "rotateX(" +
          -((e.clientY - r.top - r.height / 2) / r.height) * 8 +
          "deg) rotateY(" +
          ((e.clientX - r.left - r.width / 2) / r.width) * 8 +
          "deg)";
        if (glass) {
          glass.style.background =
            "radial-gradient(circle at " +
            (e.clientX - r.left) +
            "px " +
            (e.clientY - r.top) +
            "px,rgba(255,255,255,0.06) 0%,transparent 50%)";
          glass.style.opacity = "1";
        }
        ticking[key] = false;
      });
    });

    card.addEventListener("mouseleave", function () {
      ticking[key] = false;
      if (inner) inner.style.transform = "rotateX(0) rotateY(0)";
      if (glass) glass.style.opacity = "0";
      if (img) img.style.filter = "none";
      if (shaderEl) {
        shaderEl.classList.remove("is-active", "is-settle");
        shaderEl.classList.add("is-leaving");
      }
      leaveTimers[key] = setTimeout(function () {
        if (shaderEl) shaderEl.classList.remove("is-leaving");
        if (active[key]) {
          destroyShader(active[key]);
          delete active[key];
        }
        leaveTimers[key] = null;
      }, 400);
    });
  });

  /* ===== ATC wiring on bestseller cards (R20.31) ===== */
  /* Each card <a> has data-vid, data-title, data-collection; cart-btn triggers evAddToCart */
  /* R20.31: Immer Toast zeigen, egal wo der Benutzer steht. Drawer NICHT auto-oeffnen,
     damit die "in den Warenkorb"-Bestaetigung sichtbar bleibt. */

  /* R20.62: A11y-Fix WCAG 4.1.3 — Screen-Reader-Announcement via evLive.
     Davor: Cart-Add wurde nur visuell als Toast gezeigt, blind/SR-User wussten
     nicht ob's geklappt hat. Jetzt: zusaetzlich Text in #evLive (theme.liquid:363). */
  function _bslAnnounce(msg) {
    var live = document.getElementById("evLive");
    if (!live) return;
    var plain = msg.replace(/<[^>]+>/g, ""); /* HTML-Tags strippen fuer SR */
    /* Erst leeren, dann setzen — so triggert SR auch wenn Text gleich bleibt */
    live.textContent = "";
    setTimeout(function () {
      live.textContent = plain;
    }, 50);
  }
  /* Inline Toast-Fallback fuer Seiten ohne ev-cart-drawer (z.B. Cart-Page) */
  function _bslInlineToast(msg, kind) {
    _bslAnnounce(msg);
    if (typeof window.evToast === "function") {
      window.evToast(msg, kind || "ok");
      return;
    }
    var t = document.createElement("div");
    t.setAttribute("role", "status");
    t.setAttribute("aria-live", "polite");
    t.style.cssText =
      "position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(8px);z-index:99999;" +
      "padding:12px 22px;border-radius:12px;font-family:DM Sans,-apple-system,BlinkMacSystemFont,sans-serif;" +
      "font-size:14px;font-weight:700;color:#fff;letter-spacing:.01em;text-align:center;" +
      "background:" +
      (kind === "err" ? "#EF4444" : "#10b981") +
      ";" +
      "box-shadow:0 10px 32px rgba(0,0,0,.5);opacity:0;transition:opacity .25s ease,transform .25s ease;" +
      "max-width:calc(100vw - 32px);pointer-events:none";
    t.innerHTML = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.style.opacity = "1";
      t.style.transform = "translateX(-50%) translateY(0)";
    });
    setTimeout(function () {
      t.style.opacity = "0";
      t.style.transform = "translateX(-50%) translateY(8px)";
    }, 2400);
    setTimeout(function () {
      if (t.parentNode) t.parentNode.removeChild(t);
    }, 2700);
  }

  document
    .querySelectorAll(".bsl__card .bsl__cart-btn")
    .forEach(function (btn) {
      /* Promote to proper button semantics */
      btn.setAttribute("tabindex", "0");
      btn.setAttribute("role", "button");
      var handler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest(".bsl__card");
        if (!card) return;
        var vid = card.getAttribute("data-vid");
        var title = card.getAttribute("data-title") || "Produkt";
        var collection = card.getAttribute("data-collection");
        /* If variant ID missing or 0, route user to collection page to pick flavor */
        if (!vid || vid === "0" || vid === "") {
          if (collection) {
            window.location.href = collection;
            return;
          }
          /* Fallback to card's own href */
          if (card.href) {
            window.location.href = card.href;
            return;
          }
          return;
        }
        if (typeof window.evAddToCart === "function") {
          /* R20.31: openDrawer:false -> Toast bleibt sichtbar, Drawer ueberdeckt ihn nicht */
          window.evAddToCart(vid, {
            title: title,
            btn: btn,
            openDrawer: false,
          });
        } else {
          /* R20.31: Fallback mit Inline-Toast statt Page-Redirect */
          btn.classList.add("is-atc-loading");
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify({
              items: [{ id: parseInt(vid, 10), quantity: 1 }],
            }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error("bad");
              return r.json();
            })
            .then(function () {
              btn.classList.remove("is-atc-loading");
              btn.classList.add("is-atc-ok");
              _bslInlineToast(
                "<strong>" + title + "</strong> in den Warenkorb",
                "ok",
              );
              setTimeout(function () {
                btn.classList.remove("is-atc-ok");
              }, 1400);
            })
            .catch(function () {
              btn.classList.remove("is-atc-loading");
              _bslInlineToast("Konnte nicht hinzugefuegt werden", "err");
            });
        }
      };
      btn.addEventListener("click", handler);
      btn.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          handler(e);
        }
      });
    });

  /* R20.16: Fake-Stern-Injection entfernt (UWG-Compliance).
     Cards zeigen keine Sterne mehr, bis echte Bewertungen eingepflegt sind. */
})();
